export type DashboardPeriodFilter =
  | 'last_7_days'
  | 'last_30_days'
  | 'this_month'
  | 'today'
  | 'this_week'

export type DashboardPeriodOption = {
  key: DashboardPeriodFilter
  label: string
}

export type DashboardOrderDateFilter =
  | 'LAST_7_DAYS'
  | 'LAST_30_DAYS'
  | 'THIS_MONTH'
  | 'TODAY'
  | 'THIS_WEEK'

export const DASHBOARD_PERIOD_OPTIONS: DashboardPeriodOption[] = [
  {key: 'last_7_days', label: 'Last 7 Days'},
  {key: 'last_30_days', label: 'Last 30 Days'},
  {key: 'this_month', label: 'This Month'},
  {key: 'today', label: 'Today'},
  {key: 'this_week', label: 'This Week'},
]

export const isDashboardPeriodFilter = (value: unknown): value is DashboardPeriodFilter =>
  DASHBOARD_PERIOD_OPTIONS.some((option) => option.key === value)

const ORDER_DATE_FILTER_BY_LABEL: Record<string, DashboardOrderDateFilter> = {
  'Last 7 Days': 'LAST_7_DAYS',
  'Last 30 Days': 'LAST_30_DAYS',
  'This Month': 'THIS_MONTH',
  Today: 'TODAY',
  'This Week': 'THIS_WEEK',
}

export const getOrderDateFilter = (label: string): DashboardOrderDateFilter | undefined =>
  ORDER_DATE_FILTER_BY_LABEL[label]
